// extracted by mini-css-extract-plugin
export default {"buttonContainer":"FacebookSignInButton_buttonContainer__7BoXn","buttonText":"FacebookSignInButton_buttonText__U5BbM","buttonImg":"FacebookSignInButton_buttonImg__j4y-I"};